import { zShareModalOverlay } from 'utils/ui-helpers/stackingContexts';
import { colors } from 'utils/themes/colors';
import { spacings } from 'utils/themes/spacings';
import { radiuses } from 'utils/themes/radiuses';

export const modalStyles = {
  left: '50%',
  top: '50%',
  position: 'absolute',
  // TODO-THEME
  padding: spacings.s32,
  // TODO-THEME
  borderRadius: radiuses.r16,
  width: 487,
  height: 221,
  pointerEvents: 'auto',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#ffffff',
};

export const modalHeaderStyle = {
  fontWeight: 600,
  size: 18,
  lineHeight: '22px',
  color: '#282b36',
};

export const choiceStyles = {
  display: 'flex',
  marginTop: 'auto',
};

export const textStyles = {
  fontSize: 16,
  color: '#545869',
  lineHeight: '24px',
  maxWidth: 418,
};

export const overlayStyles = {
  width: '100vw',
  height: '100vh',
  overflowX: 'hidden',
  overflowY: 'auto',
  position: 'fixed',
  // TODO-THEME
  top: spacings.s0,
  // TODO-THEME
  left: spacings.s0,
  // TODO-THEME
  right: spacings.s0,
  // TODO-THEME
  bottom: spacings.s0,
  zIndex: zShareModalOverlay,
  // TODO-THEME
  backgroundColor: colors.backgrounds.transparent,
};
